import useSWR from "swr";
import { useMemo } from "react";
import { getAPI } from "@/lib/api";
import type { PipelineHealthData } from "./presentation";
import { creationProductRequest, readCreationProducts } from "./creationProducts";
import type { CreationMarketField } from "./creationDimensionData";

export function useCreationProducts(data: PipelineHealthData, enabled: boolean, market?: CreationMarketField) {
  const company = data.context.data;
  const request = useMemo(() => enabled ? creationProductRequest(company?.company.id, company?.rawDeals ?? [], data.asOf, market) : null,
    [enabled, company?.company.id, company?.rawDeals, data.asOf, market]);
  return useSWR(request ? ["pipeline-health-product-labels", request.companyId, request.from, request.to, request.providerIds, market?.name] : null,
    async () => readCreationProducts(request!, getAPI),
    { revalidateOnFocus: false, revalidateOnReconnect: false, errorRetryCount: 0 });
}
